// extracted by mini-css-extract-plugin
export default {"content":"TableSidebarWidget_content__hn92I","action-buttons":"TableSidebarWidget_action-buttons__6b1MP"};